import { Stack, Group, Text, Badge } from '@repletoryreach/sdk-ui';
import { StatusBadge } from '@repletoryreach/sdk-ui/data-display';
import { formatInteger } from '../../../lib/format';
import { useT } from '../../../i18n/I18nProvider';
import { hasNoConsumers, queueKey, queueTone, type Queue } from './queueState';

const MUTED = 'var(--rr-color-text-muted)';

export function QueuesList({ rows }: { rows: Queue[] }) {
  const t = useT();
  return (
    <Stack gap="xs">
      {rows.map((r) => (
        <div key={queueKey(r)} className="rr-list-row" style={{ cursor: 'default' }}>
          <Group gap="md" align="center" wrap="wrap" style={{ width: '100%' }}>
            <Stack gap={0} style={{ flex: 1, minWidth: 200 }}>
              <Text role="subtitle" fw={600} truncate><code>{r.name}</code></Text>
              <Text role="caption" c={MUTED}>
                <code>{r.vhost}</code> · {t(r.consumers === 1 ? 'queues.list.consumersOne' : 'queues.list.consumersOther', { count: r.consumers })} · {t('queues.list.total', { count: formatInteger(r.messages ?? 0) })}
              </Text>
            </Stack>
            <Stack gap={0} style={{ textAlign: 'right', flexShrink: 0, minWidth: 80 }}>
              <Text role="caption" c={MUTED}>{t('queues.columns.ready')}</Text>
              <Text role="bodySmall" fw={600}>{formatInteger(r.messages_ready ?? 0)}</Text>
            </Stack>
            <Stack gap={0} style={{ textAlign: 'right', flexShrink: 0, minWidth: 80 }}>
              <Text role="caption" c={MUTED}>{t('queues.columns.unacked')}</Text>
              <Text role="bodySmall" fw={600}>{formatInteger(r.messages_unacked ?? 0)}</Text>
            </Stack>
            {hasNoConsumers(r) && (
              <Badge size="sm" color="red" variant="light" style={{ flexShrink: 0 }}>{t('queues.noConsumersBadge')}</Badge>
            )}
            <StatusBadge status={queueTone(r)} size="sm">{r.state ?? t('status.unknown')}</StatusBadge>
          </Group>
        </div>
      ))}
    </Stack>
  );
}
